import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { PageHeader, Panel } from "@/components/dash/Ui";
import { ClicksTable } from "@/components/dash/ClicksTable";
import { DateFilter, DEFAULT_RANGE } from "@/components/dash/DateFilter";

export default function Clicks() {
  const [range, setRange] = useState(DEFAULT_RANGE);
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/clicks", { params: { start: range.start, end: range.end, q: q || undefined, limit: 1000 } })
        .then((r) => setRows(r.data));
    }, 250);
    return () => clearTimeout(t);
  }, [range, q]);

  return (
    <div>
      <PageHeader eyebrow={`${range.from} → ${range.to}`} title="Click logs">
        <DateFilter value={range} onChange={setRange} />
      </PageHeader>
      <Panel>
        <div className="relative max-w-sm mb-5">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
          <Input data-testid="clicks-search-input" value={q} onChange={(e) => setQ(e.target.value)}
            placeholder="Search IP, country, city, link, number"
            className="pl-10 bg-slate-950 border-slate-800 focus-visible:ring-emerald-500" />
        </div>
        <p className="text-xs text-slate-500 mb-3" data-testid="clicks-count">{rows.length} clicks</p>
        <ClicksTable rows={rows} />
      </Panel>
    </div>
  );
}
